"use strict";

var _objectWithoutProperties = require("/home/circleci/b2b-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/home/circleci/b2b-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _icons = require("@creditas/icons");

var _components = require("./components");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string,
  ref: _propTypes.object,
  complete: _propTypes.bool,
  message: _propTypes.string
} : {};

var defaultProps = _objectSpread(_objectSpread({}, _components.Container.defaultProps), {}, {
  component: 'div',
  complete: false
});

var Spinner = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var component = props.component,
      className = props.className,
      complete = props.complete,
      message = props.message,
      dataTest = props['data-testid'],
      others = _objectWithoutProperties(props, ["component", "className", "complete", "message", "data-testid"]);

  return (0, _core.jsx)(_components.Container, (0, _extends2.default)({
    as: component,
    ref: ref,
    className: className,
    "data-testid": dataTest
  }, props), (0, _core.jsx)(_components.Spinner, (0, _extends2.default)({
    complete: complete
  }, others), complete && (0, _core.jsx)(_icons.Action.Check, {
    color: "primary03",
    fontSize: "large"
  })), (0, _core.jsx)(_components.Text, null, message));
});

exports.Spinner = Spinner;
process.env.NODE_ENV !== "production" ? Spinner.propTypes = propTypes : void 0;
Spinner.defaultProps = defaultProps;
Spinner.displayName = 'Spinner';